export default __webpack_public_path__ + "media/images/carousel/14-5a6f4d6fcd7a494a4cc3a84a517d6adb.jpg";